import { NgClass } from '@angular/common';
import {
  Component,
  ElementRef,
  HostBinding,
  Input,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';

@Component({
  selector: 'ui-button',
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [NgClass, NzButtonModule],
})
export class UIButton {
  @Input() disabled?: boolean;
  @Input() loading?: boolean;
  @Input() block?: boolean;
  @Input() type: 'primary' | 'secondary' = 'primary';
  @Input() color: 'basic' | 'accent' | 'danger' | 'azure' | 'sky' | 'grass' = 'basic';
  @Input() size: 'large' | 'medium' | 'small' = 'medium'; // Default size

  @HostBinding('class') get buttonClasses() {
    return `ui-${this.color}-button` + ' ' + `ui-${this.size}-button`;
  }

  @ViewChild('buttonElement', {
    static: true,
    read: ElementRef<HTMLButtonElement>,
  })
  buttonElement?: ElementRef<HTMLButtonElement>;

  focus(): void {
    this.buttonElement?.nativeElement?.focus();
  }
}
